export default __webpack_public_path__ + "static/media/infinity_icon_white.5eab518b.svg";